import "ant-design-vue/es/message/style";
import _message from "ant-design-vue/es/message";
import "core-js/modules/es.array.push.js";
import { personalColumns } from '../../index.js';
import { editPersonalMsg, getInfo } from '@/api/modules/personal.js';
import store from '@/store';
export default {
  props: {
    data: {
      type: Array
    },
    tabletype: {
      type: String
    },
    loading: {
      type: Boolean
    },
    total: {
      type: Number
    }
  },
  data() {
    return {
      PageOptions: {
        page: 1,
        per: 10
      },
      personalcolumns: personalColumns,
      visible: false,
      form: this.$form.createForm(this, {
        name: 'dynamic_rule'
      }),
      editForm: {
        username: '',
        email: '',
        department_name: '',
        company_name: '',
        mobile: '',
        _id: ''
      },
      personaldata: [],
      customer_name: ''
    };
  },
  created() {
    if (localStorage.getItem('vuex')) {
      this.personaldata = [];
      this.getUserInfo();
    }
  },
  computed: {
    pagination() {
      return {
        current: this.PageOptions.page,
        'page-size': this.PageOptions.per,
        total: this.total,
        'show-quick-jumper': true,
        'show-size-changer': true,
        'show-total': () => `总共 ${this.total} 条`,
        onChange: this.changePageOptions
      };
    }
  },
  methods: {
    searchDetail(e) {
      Object.assign(this.editForm, e);
      this.visible = true;
    },
    async getUserInfo() {
      await getInfo().then(res => {
        if (res.code === 1) {
          this.personaldata = [];
          const {
            result
          } = res;
          // this.customer_name = result.customer_name;
          this.customer_name = result.username;
          this.personaldata.push(result);
        }
      });
    },
    changePageOptions(pageIndex, pageSize) {
      this.PageOptions.page = pageIndex;
      this.PageOptions.per = pageSize;
      this.$emit('getPageOption', this.PageOptions);
    },
    handleOk() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          const params = {
            _id: this.editForm._id,
            company_name: values.company_name || '',
            customer_name: values.username || '',
            department_name: values.department_name || '',
            email: values.email || '',
            mobile: values.mobile || ''
          };
          await editPersonalMsg(params).then(res => {
            if (res.code === 1) {
              _message.success('编辑成功');
              getInfo().then(res => {
                if (res.code === 1) {
                  // store.commit('user/setUserInfo', { customer_name: res.result.customer_name });
                  store.commit('user/setUserInfo', {
                    customer_name: res.result.username
                  });
                  this.personaldata = [];
                  this.personaldata.push(res.result);
                }
              }).catch(() => {
                _message.error('出错了');
              });
            }
          });
          this.visible = false;
        } else {
          this.visible = true;
        }
      });
    },
    handleCancel() {
      this.visible = false;
    }
  }
};